// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VekW","content":"styles_content__3sbOg","tableWrap":"styles_tableWrap__1cT-K"};